<form [formGroup]="amrtAcrtForm">
    <div class="col-lg-6 form-group">
        <div class="form-check form-check-inline">
            <input type="radio" name="scheduleType" formControlName="scheduleType" value="autoGenerate"
                class="form-check-input">
            <label class="form-check-label">Auto Generate</label>
        </div>
        <div class="form-check form-check-inline">
            <input type="radio" name="scheduleType" formControlName="scheduleType" value="upload"
                class="form-check-input">
            <label class="form-check-label">Upload</label>
        </div>
    </div>
    <div class="card card-body" [hidden]="af.scheduleType.value!='upload'">

        <div class="row">
            <div class="col-lg-4">
                <label>File Upload</label>
                <input id="upload_file" type="file" class="form-control form-control-sm" #file (change)="onChange(file)"
                    placeholder="Select A File">
                <!-- <p *ngIf="isFileUploaded && af.filetype.invalid && af.filetype.touched"
                    class="error nocase">
                    Please upload file
                </p> -->
            </div>
            <div *ngIf="fileName" class="col-lg-4">
                <label>Attached file</label>
                <p>{{fileName}}
                    <span class="ml-2">
                        <svg (click)="removeFile()" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path
                                d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                        </svg>
                    </span>
                </p>
            </div>
            <div class="col-lg-4">
                <button class="btn btn-link" (click)="downloadExcelFile()" type="button">Download Sample File</button>
            </div>
        </div>
    </div>
</form>

<div class="card card-body table-responsive">
    <table class="table common-table ">
        <thead>
            <tr>
                <th class="pre-wrap">Sr No</th>
                <ng-container *ngFor="let data of amrtAcrtMap|keyvalue:returnZero">
                    <th class="pre-wrap" *ngIf="data.key!='ID'">{{data.key}}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody formArrayName="{{formType}}">
            <tr *ngFor="let data of fgd.form.controls[formType]['controls']; let i=index" [formGroupName]="i">
                <td>{{i+1}}</td>
                <ng-container *ngFor="let data1 of amrtAcrtMap|keyvalue:returnZero">
                    <td *ngIf="data1.key!='ID'">
                        <input *ngIf="data1.value.fieldType=='text'" type="text" class="form-control form-control-sm"
                            formControlName="{{data1.value.prop}}" (change)="formUpdateAmrt()"
                            [ngClass]="{'is-invalid':getError(i, data1.key)}">
                        <input *ngIf="data1.value.fieldType=='number'" type="number"
                            class="form-control form-control-sm" formControlName="{{data1.value.prop}}"
                            (change)="formUpdateAmrt()" [ngClass]="{'is-invalid':getError(i, data1.key)}">
                        <div class="input-group input-group-sm" *ngIf="data1.value.fieldType=='date'">
                            <input type="text" class="form-control form-control-sm datepicker"
                                (ngModelChange)="formUpdateAmrt()" formControlName="{{data1.value.prop}}" bsDatepicker
                                [(bsValue)]="fgd.form.controls[formType]['controls'][i].controls[data1.value.prop].value"
                                placeholder="Select Payment Date"
                                [ngClass]="{'is-invalid':getError(i, data1.key) || fgd.form.controls[formType]['controls'][i].controls[data1.value.prop].invalid}">
                            <div class="input-group-append pointer">
                                <span class="input-group-text">
                                    <i class="fa fa-calendar" bsDatepicker
                                        [(bsValue)]="fgd.form.controls[formType]['controls'][i].controls[data1.value.prop].value"
                                        [ngClass]="fgd.form.controls[formType]['controls'][i].controls[data1.value.prop].disabled?'disabled':''"
                                        [bsConfig]="{ isAnimated: true }"></i>
                                </span>
                            </div>
                        </div>
                        <select *ngIf="data1.value.fieldType=='select'"
                            class="form-control form-control-sm selectpicker" formControlName="{{data1.value.prop}}"
                            title="Select {{data1.key}}" (change)="formUpdateAmrt()"
                            [ngClass]="{'is-invalid':getError(i, data1.key)}">
                            <option value="" disabled>Select {{data1.key}}</option>
                            <option *ngFor="let data of data1.value.oneOf" value="{{data}}">{{data}}</option>
                        </select>
                        <small *ngIf="data1.value.type.name=='Number'" class="text-muted">
                            {{data.controls[data1.value.prop].value?toWords.convert(data.controls[data1.value.prop].value):''}}
                        </small>
                        <span *ngIf="getError(i, data1.key)" class="error">
                            Please enter valid {{data1.key}}
                        </span>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </table>
</div>